// extracted by mini-css-extract-plugin
module.exports = {"post_title":"index-module--post_title--3hNS7","card":"index-module--card--2yMGV","card_body":"index-module--card_body--1u8uX","divide":"index-module--divide--2uEZv"};